export function areURLDescriptorsEqual(x, y) {
    if (x == y) {
        return true;
    }
    else if (!x || !y) {
        return false;
    }
    return (x.pathname == y.pathname &&
        x.search == y.search &&
        x.hash == y.hash &&
        x.state == y.state);
}
var parsePattern = /((((\/?(?:[^\/\?#]+\/+)*)([^\?#]*)))?(\?[^#]+)?)(#.*)?/;
export function createURLDescriptor(urlOrDescriptor, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.ensureTrailingSlash, ensureTrailingSlash = _c === void 0 ? true : _c, _d = _b.removeHash, removeHash = _d === void 0 ? false : _d;
    var hostname;
    var pathname;
    var query;
    var search;
    var hash;
    var state;
    if (typeof urlOrDescriptor === 'string') {
        var matches = parsePattern.exec(urlOrDescriptor);
        if (!matches) {
            throw new Error("Couldn't parse the provided URL.");
        }
        hostname = '';
        pathname = matches[2] || '';
        search = matches[6] || '';
        query = parseQuery(search);
        hash = matches[7] || '';
    }
    else {
        hostname = urlOrDescriptor.hostname || '';
        pathname = urlOrDescriptor.pathname || '';
        query = urlOrDescriptor.query || (urlOrDescriptor.search ? parseQuery(urlOrDescriptor.search) : {});
        search = urlOrDescriptor.search || stringifyQuery(query);
        hash = urlOrDescriptor.hash || '';
        state = urlOrDescriptor.state;
    }
    if (ensureTrailingSlash && pathname.length && pathname.substr(-1) !== '/') {
        pathname += '/';
    }
    return {
        hostname: hostname,
        pathname: pathname,
        query: query,
        search: search,
        hash: removeHash ? '' : hash,
        href: pathname + search + hash,
        state: state,
    };
}
export function parseQuery(queryString, leadingCharacter) {
    if (leadingCharacter === void 0) { leadingCharacter = '?'; }
    if (!queryString || queryString[0] != leadingCharacter) {
        return {};
    }
    var query = {};
    var queryParts = queryString.slice(1).split('&');
    for (var i = 0, len = queryParts.length; i < len; i++) {
        var x = queryParts[i].split('=');
        query[x[0]] = x[1] ? decodeURIComponent(x[1]) : '';
    }
    return query;
}
export function stringifyQuery(query, leadingCharacter) {
    if (leadingCharacter === void 0) { leadingCharacter = '?'; }
    var keys = Object.keys(query);
    if (keys.length === 0) {
        return '';
    }
    var parts = [];
    for (var i = 0, len = keys.length; i < len; i++) {
        var key = keys[i];
        var value = String(query[key]);
        parts.push(value === '' ? key : key + '=' + encodeURIComponent(value));
    }
    return leadingCharacter + parts.join('&');
}
export function joinPaths(a, b) {
    if (!b) {
        return a;
    }
    if (a[a.length - 1] === '/') {
        a = a.substr(0, a.length - 1);
    }
    if (b[0] === '/') {
        b = b.substr(1);
    }
    return a + '/' + b;
}
//# sourceMappingURL=URLTools.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/navi/dist/es/URLTools.js
// module id = 11
// module chunks = 0